import { legacy_createStore, applyMiddleware, compose, Store } from "redux";
import { thunk, ThunkDispatch, ThunkMiddleware } from "redux-thunk";
import { RootState, RootActions, createRootReducer } from "common/reducers";
import { CommonAsyncActions } from "common/reducers/common.async.actions";
import { composeWithDevTools, EnhancerOptions } from "redux-devtools-extension";

//TODO: Need to only do this is staging
const options: EnhancerOptions = { trace: true, traceLimit: 25 } as any as EnhancerOptions;
const composeEnhancers: typeof compose = composeWithDevTools(options);

export type RootDispatchType = ThunkDispatch<RootState, undefined, RootActions>;
export type RootStoreType = Store<RootState, RootActions> & { dispatch: RootDispatchType };
export type RootGetState = () => RootState;

export const store: RootStoreType = legacy_createStore<
  RootState,
  RootActions,
  ThunkMiddleware<RootState, RootActions>,
  {}
>(
  createRootReducer(),
  //required to make all 'future' typings happy
  //@ts-ignore
  composeEnhancers(applyMiddleware(thunk)),
);

store.dispatch(CommonAsyncActions.initChatHidden());

export type AppDispatch = typeof store.dispatch;
